import Text from 'components/Text/Text';
import React, { useContext, useMemo } from 'react';
import Apk from './components/Apk';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import {
	ApkAssignmentContext,
	IApkAssignmentContext,
} from 'modules/FirmwareAndApp/Apk/ApkAssignment/apkAssignmentState/apkAssignmentContext';
import classNames from 'classnames';
import style from './ApkList.module.scss';

const ApkList: React.FC = () => {
	const { setIDsSelectedRestaurants, searchStringForApk, IDsSelectedRestaurants, apk } =
		useContext<IApkAssignmentContext>(ApkAssignmentContext);

	const filteredApk = useMemo(() => {
		if (searchStringForApk) {
			const updatedTabletApps = apk.map((el) => {
				const filteredTabletAppsByName = el.tabletApps.filter((tabletApp) =>
					tabletApp.versionName?.toLowerCase().includes(searchStringForApk.toLowerCase()),
				);
				return { ...el, tabletApps: filteredTabletAppsByName };
			});
			return updatedTabletApps;
		}
		return apk;
	}, [searchStringForApk, apk]);

	const changeCloseStatus = (restaurantID: string) => {
		const copyIDsSelectedRestaurants = { ...IDsSelectedRestaurants };
		copyIDsSelectedRestaurants[restaurantID] = !copyIDsSelectedRestaurants[restaurantID];
		setIDsSelectedRestaurants(copyIDsSelectedRestaurants, false);
	};

	const deleteRestaurant = (restaurantID: string) => {
		const copyIDsSelectedRestaurants = { ...IDsSelectedRestaurants };
		delete copyIDsSelectedRestaurants[restaurantID];
		setIDsSelectedRestaurants(copyIDsSelectedRestaurants, true);
	};

	return (
		<div data-test="ApkList">
			{filteredApk.map((el) => {
				const wrapperClasses = classNames(style.wrapper, {
					[style.collapsedWrapper]: !IDsSelectedRestaurants[el.restaurantId],
				});
				const nameClasses = classNames(style.name, style.divWithTooltip);

				return (
					<div key={el.restaurantId + 'mainDisplayApkTab'}>
						<div className={wrapperClasses}>
							<div className={style.category}>
								<div className={nameClasses} onClick={() => changeCloseStatus(el.restaurantId)}>
									<Text
										translationKey={el.restaurantAddress}
										theme={!IDsSelectedRestaurants[el.restaurantId] ? 'secondary' : 'contrast'}
										withTooltip={true}
									/>
									<svg className={style.pointerIcon}>
										<use xlinkHref={`${breadcrumbs}#next`} />
									</svg>
								</div>
								<svg className={style.closeIcon} onClick={() => deleteRestaurant(el.restaurantId)}>
									<use xlinkHref={`${breadcrumbs}#close`} />
								</svg>
							</div>
							<div className={style.subcategory}>
								{el.tabletApps.length ? (
									<Apk data={el.tabletApps} restaurantID={el.restaurantId} />
								) : (
									<Text
										translationNameSpace="listing"
										translationKey="noApkLabel"
										theme="errorDark"
										weight="bold"
										align="center"
									/>
								)}
							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default ApkList;
